
export { default as all } from "./all.js"
export { default as any } from "./any.js"
export { default as equals } from "./equals.js"
export { default as head } from "./head.js"
export { default as ifElse } from "./ifElse.js"
export { default as map } from "./map.js"
export { default as pipe } from "./pipe.js"
export { default as prop } from "./prop.js"
export { default as propEq } from "./propEq.js"